import React from "react";
import PropTypes from "prop-types";
import SectionBlock from "./components/section-block";
import LimitAssessmentCard from "./components/limit-assessment-card";
import { SECTION_IDS } from "./constants";

/**
 * Limit Assessment section — the nav-anchored wrapper around the shared
 * LimitAssessmentCard. All of the behaviour (metrics, compact/full toggle,
 * inline-editable Proposed Limit) lives in that card, so the Credit TVR can
 * render the SAME card inside its Financial Performance subsection instead of
 * duplicating it.
 */
class CaseSummarySection extends React.Component {
    render() {
        const { innerRef, expanded, onToggle } = this.props;
        return (
            <SectionBlock
                id={SECTION_IDS.CASE_SUMMARY}
                innerRef={innerRef}
                title={"Limit Assessment"}
                subtitle={"Headline numbers and proposed limits"}
                icon={"bar-chart"}
                expanded={expanded}
                onToggle={onToggle}
            >
                <LimitAssessmentCard
                    /* SectionBlock already carries the heading. */
                    title={null}
                    caseId={this.props.caseId}
                    topMetrics={this.props.topMetrics}
                    stageId={this.props.stageId}
                    proposedLimit={this.props.proposedLimit}
                    salesProposedLimit={this.props.salesProposedLimit}
                    isRiskApprover={this.props.isRiskApprover}
                    isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                    recreditViewOnlyPermission={
                        this.props.recreditViewOnlyPermission
                    }
                    onProposedLimitChange={this.props.onProposedLimitChange}
                    onSalesProposedLimitChange={
                        this.props.onSalesProposedLimitChange
                    }
                    exposureData={this.props.exposureData}
                    exposureRefreshing={this.props.exposureRefreshing}
                    onRefreshExposure={this.props.onRefreshExposure}
                />
            </SectionBlock>
        );
    }
}

CaseSummarySection.propTypes = {
    innerRef: PropTypes.object,
    caseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    topMetrics: PropTypes.array,
    stageId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    expanded: PropTypes.bool,
    onToggle: PropTypes.func,
    proposedLimit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    salesProposedLimit: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    isRiskApprover: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
    onProposedLimitChange: PropTypes.func,
    onSalesProposedLimitChange: PropTypes.func,
    exposureData: PropTypes.object,
    exposureRefreshing: PropTypes.bool,
    onRefreshExposure: PropTypes.func
};

export default CaseSummarySection;
